export default __webpack_public_path__ + "static/media/3.ea42f702.png";